import dates from "@/latelier/imports/ui/utils/dates";

export default {
  methods: dates,
};
